// @ts-check

/**
 * Operator-facing result for one admin chat broadcast.
 *
 * A partial delivery is an error even when some rooms received the text,
 * because the composer otherwise reports a clean send.
 *
 * @param {unknown} delivered
 * @param {unknown} targeted
 * @param {unknown} [logged]
 * @returns {{ tone: 'success' | 'error', text: string }}
 */
export function adminBroadcastResult(delivered, targeted, logged = true) {
  const sentRaw = Number(delivered);
  const sent = Number.isFinite(sentRaw) ? Math.max(0, Math.floor(sentRaw)) : 0;
  const aimedRaw = Number(targeted);
  const aimed = Number.isFinite(aimedRaw) ? Math.max(0, Math.floor(aimedRaw)) : sent;
  let text = aimed > sent
    ? (sent === 0
      ? `No room received the message (${aimed} targeted)`
      : `Sent to ${sent} of ${aimed} rooms`)
    : `Sent to ${sent} rooms`;
  if (logged === false) text += '. The history row was not saved';
  const tone = aimed > sent || logged === false ? 'error' : 'success';
  return { tone, text };
}
